import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleClothStock } from '../../../Store/PHPSlice/clothStock';
import { deleteManualStock, deleteTransferGarmentStk } from '../../../Store/PHPSlice/Stock/StockApis';
import PreviewIcon from '@mui/icons-material/Preview';
import { Button } from '@mui/material';

const TableBodyTransfer = ({
    serialNumber,
    id,
    dt,
    icode,
    itemNm,
    bailno,
    pksts,
    sts,
    mclothNm,
    m1clothNm,
    m2clothNm,
    m3clothNm,
    color,
    shadeNo,
    rack,
    new_locNm,
    prev_locNm,
    trmemo,
    size,
    qty,
    balqty,
    rate,
    trsts,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    // const getDelete = useSelector((state) => state.companyData.deleteComp);
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/manual-stk-edit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const userId = '1';

    const handleDeleteClick = () => {
        // Show confirmation dialog

        dispatch(deleteTransferGarmentStk(trmemo))
            .then((res) => {
                // Reload the page to show updated results
                // toast("Stock Deleted");
                console.log(res);
                alert("Stock Deleted Successfully");
                window.location.reload();
            })
            .catch((error) => {
                // Handle any errors that occur during the deletion process
                console.error("Error deleting Item:", error);
                // toast.error("Failed to delete Item");
            });

    };

    var itemName = itemNm;
    if (mclothNm !== '') {
        itemName = `${itemNm} - ${mclothNm}`;
    }
    if (m1clothNm !== '') {
        itemName = `${itemNm} - ${mclothNm}, ${m1clothNm}`;
    }
    if (m2clothNm !== '') {
        itemName = `${itemNm} - ${mclothNm}, ${m1clothNm}, ${m2clothNm}`;
    }
    if (m3clothNm !== '') {
        itemName = `${itemNm} - ${mclothNm}, ${m1clothNm}, ${m2clothNm}, ${m3clothNm}`;
    }

    const handleViewClick = () => {
        window.open(`/manual-stk-transfer-view/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const handleTransferClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/manual-stk-transfer/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {serialNumber}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {trmemo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {itemNm}
                </TableCell>


                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {mclothNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {bailno === '' ? '-' : bailno}
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {color}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {shadeNo}
                </TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {rack}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {prev_locNm}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {new_locNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${sts === '1' && pksts === '1' ? 'disabled-icon' : ''}`} onClick={handleEditClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${sts === '1' || pksts === '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
        </>
    );
};

export default React.memo(TableBodyTransfer);
